import React, { Component } from 'react'

// lib
import classnames from 'classnames'

// ui
import Button from '../../components/uielements/button'
import { Input } from 'antd'

// icon
import { FaUpload } from 'react-icons/fa'

// redux
import { connect } from 'react-redux'
import EventActions from '../../redux/component_select_event/actions'

const { Search } = Input

class HeadBar extends Component {
    render() {
        const { selectLength } = this.props
        return (
            <div className={classnames('row', 'HeaderBar')}>
                <div>
                    Có {selectLength ? selectLength.length : 0} sự kiện được
                    chọn
                </div>
                <div>
                    <Search
                        className="SearchBox"
                        placeholder="Nhập để tìm kiếm"
                        onSearch={value => this.props.searchEvent()}
                        onChange={e =>
                            this.props.updateCurrentTextSearch(e.target.value)
                        }
                        value={this.props.textSearch}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        textSearch: state.component_select_event.textSearch,
        selectLength: state.component_select_event.selectedEvent,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateCurrentTextSearch: textSearch => {
            dispatch(EventActions.action.updateTextSearch(textSearch))
        },
        searchEvent: () => {
            dispatch(EventActions.action.searchEvent())
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HeadBar)
